document.addEventListener('DOMContentLoaded', function () {

  const bundleWrapper = document.querySelector('.bundle-wrapper');
  if(!bundleWrapper) return;

  const MAX_PER_PRODUCT = parseInt(bundleWrapper.dataset.maxPerProduct || '5', 10);
  const MAX_BUNDLE_ITEMS = parseInt(bundleWrapper.dataset.maxTotalItems || '12', 10);
  const summaryContainer = bundleWrapper.querySelector('.bundle-summary-products');
  const summarySlots = summaryContainer
    ? Array.from(summaryContainer.querySelectorAll('.bundle-summary-product'))
    : [];
  const discountsContainer = bundleWrapper.querySelector('.bundle-discounts');
  const discountItems = discountsContainer
    ? Array.from(discountsContainer.querySelectorAll('.bundle-discount'))
    : [];
  const quantityLabel = bundleWrapper.querySelector('.bundle-summary-title #quantityProducts');
  const valueBundleEl = bundleWrapper.querySelector('#valueBundle');
  const valueBundleWithDiscountEl = bundleWrapper.querySelector('#valueBundleWithDiscount');
  const valueDiscountEl = bundleWrapper.querySelector('#valueDiscount');
  const addBundleButton = bundleWrapper.querySelector('.add-bundle-to-cart');
  const addBundleVariantsContainer = bundleWrapper.querySelector('.add-bundle-variants');
  const bundleErrorEl = bundleWrapper.querySelector('[data-bundle-error]');
  let arrayList = [];
  const DISCOUNT_RULES = [
    { minQty: 2, multiplier: 0.85, percent: 15 },
    { minQty: 3, multiplier: 0.84, percent: 16 },
    { minQty: 4, multiplier: 0.83, percent: 17 },
    { minQty: 5, multiplier: 0.8, percent: 20 },
    { minQty: 6, multiplier: 0.75, percent: 25 },
    { minQty: 7, multiplier: 0.7, percent: 30 },
  ];

  function getTotalQuantity(items = arrayList) {
    return items.reduce((total, item) => total + (parseInt(item.quantity, 10) || 0), 0);
  };

  function calculateQuantityByProductId(items, productId) {
    return items
      .filter((item) => item.productId === productId)
      .reduce((total, item) => total + (parseInt(item.quantity, 10) || 0), 0);
  };

  function getQuantityByVariantId(items, variantId) {
    const item = items.find((entry) => entry.id === variantId);
    return item ? parseInt(item.quantity, 10) || 0 : 0;
  };

  function updateQuantityByVariantId(items, variantId, newQuantity) {
    return items.map((item) =>
      item.id === variantId ? { ...item, quantity: newQuantity } : item,
    );
  };

  function getDiscountRule(quantity) {
    for(let i = DISCOUNT_RULES.length - 1; i >= 0; i -= 1) {
      if(quantity >= DISCOUNT_RULES[i].minQty) return DISCOUNT_RULES[i];
    };
    return null;
  };

  function getDiscountMultiplierByQty(totalQty) {
    const rule = getDiscountRule(totalQty);
    return rule ? rule.multiplier : 1;
  };

  function updateBundlePrice(totalQty) {
    if(!valueBundleEl || !valueBundleWithDiscountEl || !valueDiscountEl) return;
    const price = arrayList.reduce(
      (total, item) => total + (Number(item.price) * (parseInt(item.quantity, 10) || 0)),
      0,
    );
    if(totalQty <= 0 || price <= 0) {
      valueBundleEl.textContent = '';
      valueBundleWithDiscountEl.textContent = '';
      valueDiscountEl.textContent = '';
      return;
    };

    const multiplier = getDiscountMultiplierByQty(totalQty);

    if(totalQty === 1 || multiplier === 1) {
      valueBundleEl.textContent = '';
      valueBundleWithDiscountEl.textContent = Shopify.formatMoney(price, moneyFormat);
      valueDiscountEl.textContent = '';
      return;
    };

    const discounted = price * multiplier;
    const saving = price - discounted;

    valueBundleEl.textContent = Shopify.formatMoney(price, moneyFormat);
    valueBundleWithDiscountEl.textContent = Shopify.formatMoney(discounted, moneyFormat);
    valueDiscountEl.textContent = Shopify.formatMoney(saving, moneyFormat);
  };

  function updateBundleDiscount(totalQty) {
    if(!discountsContainer) {
      updateBundlePrice(totalQty);
      return;
    };

    discountsContainer.setAttribute('data-current-percent', '0');
    discountItems.forEach((item) => {
      item.classList.remove('selected');
      item.classList.remove('last');
    });

    if(totalQty <= 0) {
      updateBundlePrice(totalQty);
      return;
    };

    const rule = getDiscountRule(totalQty);
    const currentPercent = rule ? rule.percent : 0;
    discountsContainer.setAttribute('data-current-percent', String(currentPercent));

    let activeCount = 1;
    if(totalQty === 1) {
      activeCount = 1;
    } else if (totalQty >= 2 && totalQty <= 4) {
      activeCount = Math.min(4, discountItems.length);
    } else if (totalQty >= 5 && totalQty <= 6) {
      activeCount = Math.min(5, discountItems.length);
    } else if (totalQty >= 7) {
      activeCount = discountItems.length;
    };

    for(let i = 0; i < activeCount; i += 1) {
      const el = discountItems[i];
      if(!el) continue;
      el.classList.add('selected');
      if(i === activeCount - 1) el.classList.add('last');
    };

    updateBundlePrice(totalQty);
  };

  function renderBundleSummary() {
    if(!summarySlots.length || !addBundleVariantsContainer) return;
    summarySlots.forEach((slot) => {
      slot.removeAttribute('data-variant-added');
      const existingImg = slot.querySelector('img');
      if(existingImg && existingImg.parentElement === slot) existingImg.remove();

      const nameEl = slot.querySelector('.variant--name');
      const qtyEl = slot.querySelector('.variant--qty');
      if(nameEl) nameEl.remove();
      if(qtyEl) qtyEl.remove();
    });

    addBundleVariantsContainer.innerHTML = '';

    let html = '';
    let slotIndex = 0;
    let flag = 1;
    let inputIndex = 0;

    arrayList.forEach((item) => {
      const { productId, quantity, id: variantId, image, variantName } = item;
      const qty = parseInt(quantity, 10) || 0;
      if(!qty) return;
      for(let k = 0; k < qty; k += 1) {
        const slot = summarySlots[slotIndex];
        if(!slot) break;
        if(k === 0) {
          slot.setAttribute('data-flag', String(flag));
          const imgEl = document.createElement('img');
          imgEl.src = image;
          imgEl.dataset.id = String(variantId);
          slot.appendChild(imgEl);
          slot.setAttribute('data-variant-added', String(variantId));
          if(variantName && variantName !== 'Default Title') {
            const nameDiv = document.createElement('div');
            nameDiv.className = 'variant--name';
            nameDiv.textContent = variantName;
            slot.appendChild(nameDiv);
          };
          const qtyDiv = document.createElement('div');
          qtyDiv.className = 'variant--qty';
          qtyDiv.textContent = String(qty);
          slot.appendChild(qtyDiv);
          slotIndex += 1;
        };
        html += `<input name="items[${inputIndex}]id" value="${variantId}" data-id="${productId}" type="hidden">`;
        inputIndex += 1;
      };
      flag += 1;
    });

    addBundleVariantsContainer.innerHTML = html;

    const totalQty = getTotalQuantity();
    if(totalQty < MAX_BUNDLE_ITEMS) setBundleErrorVisible(false);
    updateBundleDiscount(totalQty);
    if(addBundleButton) addBundleButton.disabled = totalQty === 0;
    if(quantityLabel) quantityLabel.textContent = totalQty > 0 ? `(${totalQty})` : '';
  };

  function canAddQuantity(productId, requestedQty, currentProductQty, totalBundleQty) {
    const newProductTotal = currentProductQty + requestedQty;
    const newBundleTotal = totalBundleQty + requestedQty;
    if(newProductTotal > MAX_PER_PRODUCT) return { ok: false, reason: 'product-limit' };
    if(newBundleTotal > MAX_BUNDLE_ITEMS) return { ok: false, reason: 'bundle-limit' };
    return { ok: true };
  };

  function setBundleErrorVisible(visible) {
    if(!bundleErrorEl) return;
    visible ? bundleErrorEl.classList.remove('hidden') : bundleErrorEl.classList.add('hidden');
  };

  function addItem(bundleProduct) {
    const select = bundleProduct.querySelector('select');
    const img = bundleProduct.querySelector('.product-card-img');
    const qtyInput = bundleProduct.querySelector('.quantity-input');
    if(!select || !img || !qtyInput) return false;

    const variantId = select.value;
    const variantName = select.options[select.selectedIndex]
      ? select.options[select.selectedIndex].text
      : '';
    const qty = parseInt(qtyInput.value, 10) || 1;
    const price = Number(img.dataset.price || 0);
    const image = img.dataset.image || '';
    const productId = img.dataset.productId ? String(img.dataset.productId) : '';

    if(!productId || !variantId) return false;

    const totalBundleQty = getTotalQuantity();
    const currentProductQty = calculateQuantityByProductId(arrayList, productId);

    const check = canAddQuantity(productId, qty, currentProductQty, totalBundleQty);
    if(!check.ok) {
      if(check.reason === 'bundle-limit') setBundleErrorVisible(true);
      bundleProduct.classList.remove('selected');
      return false;
    };

    const existing = arrayList.find((item) => item.id === variantId);
    if(existing) {
      const newQty = (parseInt(existing.quantity, 10) || 0) + qty;
      const nextCheck = canAddQuantity(productId, qty, currentProductQty, totalBundleQty);
      if(!nextCheck.ok) {
        bundleProduct.classList.remove('selected');
        return false;
      };
      existing.quantity = newQty;
    } else {
      arrayList.push({ productId, quantity: qty, id: variantId, image, price, variantName });
    };
    return true;
  };

  function removeItem(bundleProduct) {
    const select = bundleProduct.querySelector('select');
    if(!select) return;
    const variantId = select.value;
    arrayList = arrayList.filter((item) => item.id !== variantId);
  };

  function removeItemByVariantId(variantId) {
    arrayList = arrayList.filter((item) => item.id !== variantId);
  };

  function updateQtyPlusButton(bundleProduct, productId) {
    const resultQty = calculateQuantityByProductId(arrayList, productId);
    const plusBtn = bundleProduct.querySelector('.qtyplus');
    if(!plusBtn) return;
    plusBtn.classList.toggle('disabled', resultQty >= MAX_PER_PRODUCT);
  };

  function animateProductToSummary(bundleProduct) {
    if(!summarySlots.length) return;
    const img =
      bundleProduct.querySelector('.product-card-img img') ||
      bundleProduct.querySelector('.product-card-img');
    const targetSlot = summarySlots.find((slot) => !slot.querySelector('img'));
    if(!img || !targetSlot) return;

    const imgRect = img.getBoundingClientRect();
    const targetRect = targetSlot.getBoundingClientRect();
    const clone = img.cloneNode(true);
    if(!(clone instanceof HTMLElement)) return;

    clone.style.position = 'fixed';
    clone.style.left = `${imgRect.left}px`;
    clone.style.top = `${imgRect.top}px`;
    clone.style.width = `${imgRect.width}px`;
    clone.style.height = `${imgRect.height}px`;
    clone.style.pointerEvents = 'none';
    clone.style.zIndex = '9999';
    clone.style.transition = 'transform 0.6s ease, opacity 0.6s ease';
    clone.style.transform = 'translate(0, 0)';
    document.body.appendChild(clone);

    const deltaX = targetRect.left - imgRect.left;
    const deltaY = targetRect.top - imgRect.top;

    requestAnimationFrame(() => {
      clone.style.transform = `translate(${deltaX}px, ${deltaY}px) scale(0.5)`;
      clone.style.opacity = '0.2';
    });

    clone.addEventListener(
      'transitionend',
      () => {
        clone.remove();
      },
      { once: true },
    );
  };

  bundleWrapper.addEventListener('click', (event) => {
    const target = event.target;
    if(!(target instanceof Element)) return;
    if(target.closest('.qtybox') || target.closest('.quantity-input')) return;
    if(target.closest('.product-item__size')) return;

    const productImg = target.closest('.bundle-product .product-card-img');
    if(productImg) {
      const bundleProduct = productImg.closest('.bundle-product');
      if(!bundleProduct) return;

      const img = bundleProduct.querySelector('.product-card-img');
      const productId = img && img.dataset.productId ? String(img.dataset.productId) : '';
      const select = bundleProduct.querySelector('select');
      const variantId = select ? select.value : '';

      const resultQty = productId ? calculateQuantityByProductId(arrayList, productId) : 0;
      const resultVariantQty = variantId ? getQuantityByVariantId(arrayList, variantId) : 0;
      if(resultQty >= MAX_PER_PRODUCT && !resultVariantQty) return;

      const wasSelected = bundleProduct.classList.contains('selected');

      if(wasSelected) {
        bundleProduct.classList.remove('selected');
        removeItem(bundleProduct);
      } else {
        bundleProduct.classList.add('selected');
        const added = addItem(bundleProduct);
        if(!added) return;
        animateProductToSummary(bundleProduct);
      };
      if(productId) updateQtyPlusButton(bundleProduct, productId);
      renderBundleSummary();
      return;
    };
  });

  bundleWrapper.addEventListener('change', (event) => {
    const target = event.target;
    if(!(target instanceof HTMLSelectElement)) return;
    if(!target.closest('.product-item__size')) return;

    const bundleProduct = target.closest('.bundle-product');
    if(!bundleProduct) return;

    const img = bundleProduct.querySelector('.product-card-img');
    const productId = img && img.dataset.productId ? String(img.dataset.productId) : '';
    const variantId = target.value;

    const resultQty = productId ? calculateQuantityByProductId(arrayList, productId) : 0;
    const resultVariantQty = variantId ? getQuantityByVariantId(arrayList, variantId) : 0;

    bundleProduct.dataset.variant = variantId;
    if(img) img.dataset.variant = variantId;

    const plusBtn = bundleProduct.querySelector('.qtyplus');
    if(plusBtn && resultQty < MAX_PER_PRODUCT) plusBtn.classList.remove('disabled');

    const qtyInput = bundleProduct.querySelector('#quantity');
    if(!qtyInput) return;

    if(resultVariantQty) {
      bundleProduct.classList.add('selected');
      qtyInput.value = String(resultVariantQty);
      bundleProduct.classList.remove('disabled');
    } else {
      bundleProduct.classList.remove('selected');
      qtyInput.value = '1';
      resultQty >= MAX_PER_PRODUCT ? bundleProduct.classList.add('disabled') : bundleProduct.classList.remove('disabled');
      if(plusBtn && resultQty >= MAX_PER_PRODUCT - 1) plusBtn.classList.add('disabled');
    };
    renderBundleSummary();
  });

  bundleWrapper.addEventListener('click', (event) => {
    const target = event.target;
    if(!(target instanceof Element)) return;
    const btn = target.closest('.qtybox .btnqty');
    if(!btn) return;

    const bundleProduct = btn.closest('.bundle-product');
    if(!bundleProduct) return;

    const isPlus = btn.classList.contains('qtyplus');
    const qtyInput = bundleProduct.querySelector('.quantity-input');
    const img = bundleProduct.querySelector('.product-card-img');
    const select = bundleProduct.querySelector('select');

    if(!qtyInput || !img) return;

    let qty = parseInt(qtyInput.value, 10) || 1;
    const productId = img.dataset.productId ? String(img.dataset.productId) : '';
    const variantId = select ? select.value : '';

    const totalBundleQty = getTotalQuantity();
    const productQtyInBundle = productId
      ? calculateQuantityByProductId(arrayList, productId)
      : 0;
    const variantQtyInBundle = variantId ? getQuantityByVariantId(arrayList, variantId) : 0;

    if(isPlus) {
      const proposedQty = qty + 1;
      const newProductTotal = productQtyInBundle - variantQtyInBundle + proposedQty;
      const newBundleTotal = totalBundleQty - variantQtyInBundle + proposedQty;

      if(proposedQty > MAX_PER_PRODUCT || newProductTotal > MAX_PER_PRODUCT) {
        btn.classList.add('disabled');
        return;
      };

      if(newBundleTotal > MAX_BUNDLE_ITEMS) {
        setBundleErrorVisible(true);
        btn.classList.add('disabled');
        return;
      };
      qty = proposedQty;
    } else {
      if(qty > 1) qty -= 1;
      const plusBtn = bundleProduct.querySelector('.qtyplus');
      if(plusBtn) plusBtn.classList.remove('disabled');
    };

    qtyInput.value = String(qty);

    if(variantId && variantQtyInBundle) {
      arrayList = updateQuantityByVariantId(arrayList, variantId, qty);
      renderBundleSummary();
    };
  });

  if(addBundleButton) {
    addBundleButton.addEventListener('click', () => {
      setTimeout(() => {
        const qtyInputs = bundleWrapper.querySelectorAll('.product-card-img .quantity-input');
        qtyInputs.forEach((input) => {
          input.value = '1';
        });

        const bundleProducts = bundleWrapper.querySelectorAll('.bundle-product');
        bundleProducts.forEach((el) => {
          el.classList.remove('selected');
          el.classList.remove('disabled');
        });

        summarySlots.forEach((slot) => {
          slot.removeAttribute('data-variant-added');

          const img = slot.querySelector('img');
          if(img && img.parentElement === slot) img.remove();

          const nameEl = slot.querySelector('.variant--name');
          const qtyEl = slot.querySelector('.variant--qty');
          if(nameEl) nameEl.remove();
          if(qtyEl) qtyEl.remove();
        });

        if(quantityLabel) quantityLabel.textContent = '';
        if(valueBundleEl) valueBundleEl.textContent = '';
        if(valueBundleWithDiscountEl) valueBundleWithDiscountEl.textContent = '';
        if(valueDiscountEl) valueDiscountEl.textContent = '';

        discountItems.forEach((item) => {
          item.classList.remove('selected');
          item.classList.remove('last');
        });

        addBundleButton.disabled = true;
        arrayList = [];
      }, 1500);
    });
  };

  bundleWrapper.addEventListener('click', (event) => {
    const target = event.target;
    if(!(target instanceof Element)) return;

    const removeButton = target.closest('.bundle-summary-product .remove-from-bundle');
    if(!removeButton) return;

    const summaryProduct = removeButton.closest('.bundle-summary-product');
    if(!summaryProduct) return;

    const img = summaryProduct.querySelector('img');
    const variantId = img && img.dataset.id ? String(img.dataset.id) : '';
    if(!variantId) return;

    removeItemByVariantId(variantId);

    const productItems = bundleWrapper.querySelectorAll('.product-card-item');
    productItems.forEach((el) => {
      if(el.dataset.variant === variantId) el.classList.remove('selected');
    });

    renderBundleSummary();
  });

  const summaryOpen = bundleWrapper.querySelector('.bundle-summary-open');
  if(summaryOpen) {
    summaryOpen.addEventListener('click', () => {
      if(window.innerWidth < 1024) {
        const parent = summaryOpen.parentElement;
        if(parent) parent.classList.toggle('active');
      };
    });
  };
});